export default {
  state: {
    clickId: "",
    selectedGame: {},
    cancelMobileNumber: "",
    channel: "",
    isSubscribed: false,
  },

  mutations: {
    SET_CLICKID(state, payload) {
      state.clickId = payload;
    },

    SET_SELECTEDGAME(state, payload) {
      state.selectedGame = payload;
    },

    SET_CANCELMOBILENUMBER(state, payload) {
      state.cancelMobileNumber = payload;
    },

    SET_CHANNEL(state, payload) {
      state.channel = payload;
    },

    SET_ISSUBSCRIBED(state, payload) {
      state.isSubscribed = payload;
    },
  },

  actions: {
    ADD_CLICKID: ({ commit }, payload) => {
      commit("SET_CLICKID", payload);
    },

    ADD_SELECTEDGAME: ({ commit }, payload) => {
      commit("SET_SELECTEDGAME", payload);
    },

    ADD_CANCELMOBILENUMBER: ({ commit }, payload) => {
      commit("SET_CANCELMOBILENUMBER", payload);
    },

    ADD_CHANNEL: ({ commit }, payload) => {
      commit("SET_CHANNEL", payload);
    },

    ADD_ISSUBSCRIBED: ({ commit }, payload) => {
      commit("SET_ISSUBSCRIBED", payload);
    },
  },

  getters: {
    GET_ISSUBSCRIBED: (state) => state.isSubscribed,
    GET_CLICKID: (state) => state.clickId,
    GET_SELECTEDGAME: (state) => state.selectedGame,
    GET_CANCELMOBILENUMBER: (state) => state.cancelMobileNumber,
    GET_CHANNEL: (state) => state.channel,
  },
};
